/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Region } from '../../models/region';

export interface SaveRegion$Params {
   body: Region;
}

export function saveRegion(
   http: HttpClient,
   rootUrl: string,
   params: SaveRegion$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Region>> {
   const rb = new RequestBuilder(rootUrl, saveRegion.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Region>;
      })
   );
}

saveRegion.PATH = '/api/weather/region';
